import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PageNames } from 'src/app/configs/page-names.enum';

import { GetRulesByClientDto, SetRateLimitRule } from 'src/app/core/api/models';
import { ApiTokenService, EnumsService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { ApiNotificationService } from 'src/app/core/services/api-notification.service';
import { PermissionService } from 'src/app/core/services/authentication/permission.service';
import { DialogService } from 'src/app/core/services/dialog.service';
import { DynamicTabService } from 'src/app/core/services/dynamic-tab.service';
import { DynamicTableService } from 'src/app/core/services/dynamic-table.service';
import { LoggerService } from 'src/app/core/services/logger.service';
import { ClientRulesFormComponent } from "./client-rules-form/client-rules-form.component";
import { TranslationModule } from 'src/app/i18n';
import { JsonFormatterDirective } from 'src/app/core/directives/json-formatter.directive';
import { ListGroupItemModule } from "../../../../shared/global/list-group-item/list-group-item.module";
import { PageHeaderModule } from "../../../../shared/global/page-header/page-header.module";
import { PageBodyModule } from "../../../../shared/global/page-body/page-body.module";
import { MatTooltipModule } from '@angular/material/tooltip';
import { CheckValuePipe } from 'src/app/core/pipes/value.pipe';
import { ThemeColorDirective } from 'src/app/core/utils/theme/theme-color.directive';

@Component({
    selector: 'app-client-rules',
    templateUrl: './client-rules.component.html',
    styleUrls: ['./client-rules.component.scss'],
    imports: [
        CommonModule,
        ClientRulesFormComponent,
        TranslationModule,
        JsonFormatterDirective,
        ListGroupItemModule,
        PageHeaderModule,
        PageBodyModule,
        MatTooltipModule,
        CheckValuePipe,
        ThemeColorDirective,
    ]
})
export class ClientRulesComponent implements OnInit {
  //#region Properties
  @Input() apiTokenId;
  @Input('model') model: GetRulesByClientDto = {};
  clientRules;

  pageName = PageNames.clientRules;
  fields = 'pages.clientRules.form.fields.';
  title = 'pages.clientRules.title';
  isVisibleForm: boolean = false;
  isEdit: boolean = false;
  protected onDestroy$ = new Subject<void>();

  @Output('closePage') output_closPage = new EventEmitter<boolean>();

  //#endregion

  constructor(
    protected currentService: ApiTokenService,
    public dialogService: DialogService,
    public apiNotificationService: ApiNotificationService,
    public dynamicTableService: DynamicTableService,
    protected permissionService: PermissionService,
    protected enumService: EnumsService,
    public dynamicTabService: DynamicTabService,
    protected loggerService: LoggerService
  ) {}

  //#region init
  ngOnInit() {
    this.getClientRules();
  }

  getClientRules() {
    try {
      if (this.model.clientRules != null && this.model.clientRules != '') {
        let clientRule = '[' + this.model.clientRules + ']';
        this.clientRules = <SetRateLimitRule>JSON.parse(clientRule);
      }
    } catch (error) {
      this.loggerService.logError(
        'app-client-rules',
        error,
        EventTypes.setting
      );
    }
  }
  //#endregion

  //#region api
  // get model
  getModelApi() {
    this.unSubs();
    this.clientRules = null;
    this.currentService
      .apiTokenGetClientRulesById({ ApiTokenId: this.apiTokenId })
      .subscribe((item) => {
        if (item) {
          this.model = item?.data;
          this.getClientRules();
        }
      });
  }

  getUpdateModelApi() {
    this.unSubs();
    this.clientRules = null;
    this.currentService
      .apiTokenUpdateClientRulesGet({ ApiTokenId: this.apiTokenId })
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((res) => {
        if (res) {
          this.isVisibleForm = true;
          this.isEdit = true;
          this.model = res.data;
          this.getClientRules();
        }
      });
  }

  //for authorize
  showFormApi() {
    this.unSubs();
    this.currentService
      .apiTokenCreateClientRulesGet()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((res) => {
        if (res) {
          this.isVisibleForm = true;
          this.isEdit = false;
        }
      });
  }
  //#endregion

  //#endregion

  onUpdate() {
    this.getUpdateModelApi();
  }

  getFormResponse(isSuccess) {
    if (isSuccess) this.getModelApi();

    this.isVisibleForm = false;
    this.unSubs();
  }

  unSubs() {
    this.onDestroy$.next();
  }
  onClose() {
    this.output_closPage.emit(true);
  }
}
